import {
    Injectable
} from '@angular/core';
import Swal from 'sweetalert2';
import {
    HttpClient,
    HttpHeaders,
} from '@angular/common/http';
import {
    Observable,
    throwError
} from 'rxjs';
import {
    retry,
    catchError
} from 'rxjs/operators';
import {
    environment
} from '../../../environments/environment';
import { AuthenticationService } from './auth.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from '@ngx-translate/core';
import * as CryptoJS from 'crypto-js';
import lottie from 'lottie-web';

@Injectable({
    providedIn: 'root'
})

export class LandaService {
    apiURL = environment.apiURL;
    imageURL = environment.imageURL;
    projectURL = environment.projectURL;
    userDetail: any;
    httpOptions: any;
    user:any;
    
    urlimages: any;
    constructor(private http: HttpClient, 
                private router: Router,
                private authenticationService: AuthenticationService,
                public translate: TranslateService,
                private spinner: NgxSpinnerService) {
                    
        translate.addLangs(['IND', 'ENG']);
        this.userDetail = this.authenticationService.getDetailUser();
        this.user = null;
        if(this.userDetail !== null && Object.prototype.hasOwnProperty.call(this.userDetail, 'client')){
            this.user = {
                client: this.userDetail.client,
                email: this.userDetail.email,
                foto: this.userDetail.foto,
                foto_profil: this.userDetail.foto_profil,
                id: this.userDetail.id,
                karyawan_data_id: this.userDetail.karyawan_data_id,
                m_jabatan_id: this.userDetail.m_jabatan_id,
                karyawan_perusahaan: this.userDetail.karyawan_perusahaan,
                jabatanTxt: this.userDetail.jabatanTxt,
                bahasa: this.userDetail.bahasa,
                m_perusahaan: this.userDetail.m_perusahaan,
                nama: this.userDetail.nama,
                nik: this.userDetail.nik,
                safeEmail: this.userDetail.safeEmail,
                safeEmailId: this.userDetail.safeEmailId,
                statusTxt: this.userDetail.statusTxt,
                tipe: this.userDetail.tipe,
                uid: this.userDetail.uid,
                userId: this.userDetail.userId,
                menitPassword: this.userDetail.menitPassword,
                akses_departemen: this.userDetail.akses_departemen,
                m_roles_id: this.userDetail.m_roles_id,
                last_login: this.userDetail.last_login,
                akses_perusahaan: this.userDetail.akses_perusahaan,
                akses_karyawan_beberapa: this.userDetail.akses_karyawan_beberapa,
                akses_karyawan_list: this.userDetail.akses_karyawan_list,
                is_db_general: this.userDetail.is_db_general,
                totalKaryawan: this.userDetail.totalKaryawan,
                totalKaryawan_tidakaktif: this.userDetail.totalKaryawan_tidakaktif,
                totalPerusahaan: this.userDetail.totalPerusahaan,
                max_karyawan: this.userDetail.max_karyawan,
                max_perusahaan: this.userDetail.max_perusahaan,
                versi_app: this.userDetail.versi_app

            }
        }
        
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + btoa(JSON.stringify(this.user)),
                'Mode': 'live'
            }),
            withCredentials: true
        };
    }

    ngOnInit(): void {
        
    }

    checkAkses(hakAkses, subAkses){
        this.userDetail = this.authenticationService.getDetailUser();
        let status = false;
        if(Object.prototype.hasOwnProperty.call(this.userDetail, 'akses') && Object.prototype.hasOwnProperty.call(this.userDetail.akses, hakAkses)){
            if(Object.prototype.hasOwnProperty.call(this.userDetail.akses[hakAkses], subAkses) && this.userDetail.akses[hakAkses][subAkses]){
                status = this.userDetail.akses[hakAkses][subAkses];
            }else{
                status = false;
            }
        }
        return status;
    }

    checkAksesBackoffice(){
        this.userDetail = this.authenticationService.getDetailUser();
        if(this.userDetail.tipe != "super admin"){

            this.router.navigateByUrl('/', {skipLocationChange: true});
        }
    }
    
    checkAksesClient(){
        this.userDetail = this.authenticationService.getDetailUser();
        if(this.userDetail.tipe == "super admin"){
            this.router.navigateByUrl('/backoffice/fitur', {skipLocationChange: true});
        }
      
    }
    
    getImagePerusahaan(folder:string, image: string) {
        let ret;
        this.urlimages = this.getDetailProject().folderimg;
        if (image != '' && image != null){

            var str = image;
            var strPos = str.indexOf("https://test-humanis-bucket");//9
            
            if(strPos == 0){
                ret = image;
            }else {
                if (image != '' && image != null && folder != '') {
                    ret = this.imageURL + folder + '/' + image;
                } else if (image != '' && image != null && folder == '') {
                    ret = this.imageURL + image;
                } else {
                    ret = this.imageURL + this.urlimages + 'default.png';
                }
            }
        }else {
            ret = this.imageURL + this.urlimages + 'no-image.png';
        }

        return ret;
    }

    getImagePerusahaanNew(folder:string, image: string) {
        let ret;
        this.urlimages = this.getDetailProject().folderimg;
        if (image != '' && image != null){

            var str = image;
            var strPos = str.indexOf("https://test-humanis-bucket");//9
            
            if(strPos == 0){
                ret = image;
            }else {
                if (image != '' && image != null && folder != '') {
                    ret = image;
                } else if (image != '' && image != null && folder == '') {
                    ret = image;
                } else {
                    ret = 'no-image.png';
                }
            }
        }else {
            ret = this.imageURL + this.urlimages + 'no-image.png';
        }

        return ret;
    }
    getImage(folder:string, image: string) {
        let ret;
        
        if (image != '' && image != null){

            var str = image;
            var strPos = str.indexOf("https://test-humanis-bucket");//9
            
            if(strPos == 0){
                ret = image;
            }else {
                if (image != '' && image != null && folder != '') {
                    ret = this.imageURL + folder + '/' + image;
                } else if (image != '' && image != null && folder == '') {
                    ret = this.imageURL + image;
                } else {
                    ret = this.imageURL + 'user.png';
                }
            }
        }else {
            ret = this.imageURL + 'user.png';
        }

        return ret;
    }
    getImageByGender(folder:string, image: string, jenkel: any) {
        let ret;
        
        if (image != '' && image != null){

            var str = image;
            var strPos = str.indexOf("https://test-humanis-bucket");//9
            
            if(strPos <= 0){
                ret = image;
            }else {
                if (image != '' && image != null && folder != '') {
                    ret = this.imageURL + folder + '/' + image;
                } else if (image != '' && image != null && folder == '') {
                    ret = this.imageURL + image;
                } else {
                    ret = this.imageURL + 'user.png';
                }
            }
        }else {
            if(jenkel == 1){
                ret = this.imageURL + 'man-karyawan.png';
            }else if(jenkel == 2){
                ret = this.imageURL + 'woman.png';
            }else{
                ret = this.imageURL + 'user.png';
            }
        }

        return ret;
    }
    getImagePanjang(folder:string, image: string) {
        let ret;
        
        if (image != '' && image != null){

            var str = image;
            var strPos = str.indexOf("https://test-humanis-bucket");//9
            
            if(strPos == 0){
                ret = image;
            }else {
                if (image != '' && image != null && folder != '') {
                    ret = this.imageURL + folder + '/' + image;
                } else if (image != '' && image != null && folder == '') {
                    ret = this.imageURL + image;
                } else {
                    ret = this.imageURL + 'logo_panjang.png';
                }
            }
        }else {
            ret = this.imageURL + 'user.png';
        }

        return ret;
    }
    getImageTtd(folder:string, image: string) {
        let ret;
        
        if (image != '' && image != null){

            var str = image;
            var strPos = str.indexOf("https://test-humanis-bucket");//9
            
            if(strPos == 0){
                ret = image;
            }else {
                if (image != '' && image != null && folder != '') {
                    ret = this.imageURL + folder + '/' + image;
                } else if (image != '' && image != null && folder == '') {
                    ret = this.imageURL + image;
                } else {
                    ret = this.imageURL + 'logo_panjang.png';
                }
            }
        }else {
            ret = this.imageURL + 'tanda-tangan.png';
        }

        return ret;
    }
    DataGet(path, payloads) {
        this.setUser();
        return this.http.get(this.apiURL + path, {params: payloads, withCredentials: true, headers: this.httpOptions.headers});
    }

    DataGetBlob(path, payloads, useGoApi: boolean = false) {
        this.setUser();
        const base = useGoApi ? environment.goApiURL : this.apiURL;

        let headers = this.httpOptions.headers;
        if (useGoApi) {
            const goToken = localStorage.getItem('goToken');
            if (!goToken) {
                // goToken tidak ada — session lama sebelum Go diaktifkan.
                // Throw error yang tidak memicu logout interceptor (bukan 401/403).
                throw new Error('Session belum memiliki Go token. Silakan logout dan login ulang.');
            }
            headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + goToken,
                'Mode': 'live',
            });
        }

        return this.http.get(base + path, {params: payloads, withCredentials: true, headers, responseType: 'blob'});
    }

    // Body sudah ter-encode (`a=1&b[]=2`). Dipakai untuk unduh file yang
    // payload-nya terlalu panjang untuk query string (BE balas 414).
    DataPostBlob(path, encodedBody: string) {
        this.setUser();
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + btoa(JSON.stringify(this.user)),
            'Mode': 'live'
        });
        return this.http.post(this.apiURL + path, encodedBody, {withCredentials: true, headers, responseType: 'blob'});
    }

    /**
     * Unduh Blob sebagai berkas.
     *
     * Anchor WAJIB dilampirkan ke DOM: Firefox mengabaikan click() pada elemen
     * yang belum ada di dokumen. revokeObjectURL ditunda satu tick supaya
     * pencabutan tidak membatalkan unduhan yang baru saja dijadwalkan.
     */
    unduhBlob(blob: Blob, filename: string) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 0);
    }

    /**
     * Blob dari endpoint unduhan BISA berisi PENOLAKAN server, bukan berkas.
     * unprocessResponse() (systems.php) SELALU withStatus(200) -- kode galat
     * cuma ada di body sebagai status_code -- jadi respons 200 tetap masuk
     * callback SUKSES walau isinya JSON `{"status_code":422,"errors":[...]}`.
     *
     * blob.type TIDAK CUKUP diandalkan: unprocessResponse() tidak pernah
     * mengubah Content-Type response, jadi ia tetap default Slim3
     * ('text/html; charset=UTF-8') -- sama dengan respons HTML yang BERHASIL,
     * dan kosong bila BE tidak mengirim header sama sekali. Karena itu isi blob
     * disniff sebagai JSON; blob.type hanya dipakai sebagai jalan pintas untuk
     * tipe biner yang tidak mungkin berupa badan JSON galat.
     *
     * Membaca isi Blob bersifat asinkron -- pakai FileReader + callback (bukan
     * Blob.text(): target lib Angular 9 repo ini belum menyediakannya).
     *
     * @param selesai callback(errors) -- null berarti blob sah, pakai apa adanya.
     *                Array kosong berarti galat tanpa pesan dari BE; pemanggil
     *                yang menentukan teks penggantinya.
     */
    bacaGalatBlob(blob: Blob, selesai: (errors: any) => void) {
        const tipe = (blob && blob.type) || '';
        if (tipe.indexOf('pdf') !== -1 || tipe.indexOf('spreadsheet') !== -1 || tipe.indexOf('excel') !== -1) {
            selesai(null);
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            let errors = null;
            try {
                const body = JSON.parse(String(reader.result || ''));
                if (body && typeof body === 'object' && 'errors' in body) {
                    errors = Array.isArray(body.errors) ? body.errors : [];
                }
            } catch (e) {
                // Bukan JSON -> berkas sah (HTML/biner), lanjut apa adanya.
            }
            selesai(errors);
        };
        reader.onerror = () => selesai([]);
        reader.readAsText(blob);
    }

    DataPost(path, payloads, isHtml: boolean = false) {
        if(isHtml === true){
            this.setUser();

            let reqHeader = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + btoa(JSON.stringify(this.user)),
                    'Mode': 'live'
                }),
                responseType: 'text' as 'json' ,
                withCredentials: true
            };
            return this.http.post(this.apiURL + path, payloads, reqHeader);
        }else{
            let reqHeader = this.httpOptions;
            return this.http.post(this.apiURL + path, payloads, reqHeader);
        }

    }

    // -----------------------------------------------------------------
    // humanis-be-go helpers
    //
    // STANDARD: every call to environment.goApiURL MUST go through these
    // helpers. They guarantee the Authorization: Bearer <goToken> header is
    // attached, sourced from localStorage.getItem('goToken'). Do not bypass
    // them by calling http.get/http.post directly to goApiURL — relying on
    // the HttpConfigInterceptor alone has proven flaky (it silently no-ops
    // when goToken is missing or when URL prefix matching fails).
    //
    // If goToken is empty the helpers still issue the request without an
    // Authorization header so humanis-be-go responds with a clear 401, which
    // surfaces the missing-login state instead of failing silently.
    // -----------------------------------------------------------------

    // Dipakai flow yang harus jalan tanpa sesi login web (mis. webview mobile
    // dengan payload encoded-user): payload URL hanya kredensial PHP, bukan JWT,
    // jadi goToken tidak pernah terisi dan request ke Go akan dijawab 401.
    hasGoToken(): boolean {
        return !!localStorage.getItem('goToken');
    }

    private goHeaders(): HttpHeaders {
        const token = localStorage.getItem('goToken') || '';
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        });
        if (token) {
            headers = headers.set('Authorization', 'Bearer ' + token);
        }
        return headers;
    }

    GoDataGet(path: string, payloads?: any) {
        return this.http.get(environment.goApiURL + path, {
            params: payloads,
            headers: this.goHeaders(),
        });
    }

    GoDataPost(path: string, payloads?: any) {
        return this.http.post(environment.goApiURL + path, payloads, {
            headers: this.goHeaders(),
        });
    }
    DataPostGoMultipart(path: string, formData: FormData) {
        const goToken = localStorage.getItem('goToken');
        if (!goToken) {
            throw new Error('Session belum memiliki Go token. Silakan logout dan login ulang.');
        }
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + goToken,
            'Mode': 'live',
        });
        return this.http.post(environment.goApiURL + path, formData, { headers, withCredentials: true });
    }

    //Fungsi ini digunakan untuk dari lokal ke test
    //Berguna untuk megecek kembali bearer apabila belum tersetting setelah login di beda domain
    setUser(){
        if(this.userDetail !== null && Object.prototype.hasOwnProperty.call(this.userDetail, 'client') && this.user == null){
            this.user = {
                client: this.userDetail.client,
                email: this.userDetail.email,
                foto: this.userDetail.foto,
                foto_profil: this.userDetail.foto_profil,
                id: this.userDetail.id,
                karyawan_data_id: this.userDetail.karyawan_data_id,
                m_jabatan_id: this.userDetail.m_jabatan_id,
                karyawan_perusahaan: this.userDetail.karyawan_perusahaan,
                jabatanTxt: this.userDetail.jabatanTxt,
                bahasa: this.userDetail.bahasa,
                m_perusahaan: this.userDetail.m_perusahaan,
                nama: this.userDetail.nama,
                nik: this.userDetail.nik,
                safeEmail: this.userDetail.safeEmail,
                safeEmailId: this.userDetail.safeEmailId,
                statusTxt: this.userDetail.statusTxt,
                tipe: this.userDetail.tipe,
                uid: this.userDetail.uid,   
                userId: this.userDetail.userId,
                menitPassword: this.userDetail.menitPassword,
                akses_departemen: this.userDetail.akses_departemen,
                m_roles_id: this.userDetail.m_roles_id,
                last_login: this.userDetail.last_login,
                akses_perusahaan: this.userDetail.akses_perusahaan,
                akses_karyawan_beberapa: this.userDetail.akses_karyawan_beberapa,
                akses_karyawan_list: this.userDetail.akses_karyawan_list,
                is_db_general: this.userDetail.is_db_general,
                totalKaryawan: this.userDetail.totalKaryawan,
                totalKaryawan_tidakaktif: this.userDetail.totalKaryawan_tidakaktif,
                totalPerusahaan: this.userDetail.totalPerusahaan,
                max_karyawan: this.userDetail.max_karyawan,
                max_perusahaan: this.userDetail.max_perusahaan,
                versi_app: this.userDetail.versi_app

            }
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + btoa(JSON.stringify(this.user)),
                    'Mode': 'live'
                }),
                withCredentials: true
            };
        }

    }

    numberFormatRupiah(nominal){
        const formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0
        })
        return formatter.format(nominal);
    }

    /**
     * Alert
     */
     alertSuccess(title, content, html = false, timer = 2) {
        if(html == false){
            return this.customAlert(
                'success',
                title,
                content,
                false,
                false,
            )
            // Swal.fire({
            //     title,
            //     text: content,
            //     icon: 'success',
            //     timer: timer*1000,
            //     showConfirmButton: false,
            // });
        }else if(html == true){
            Swal.fire({
                title,
                html: content,
                icon: 'success',
                timer: timer*1000,
                showConfirmButton: false,
            });
        }
    }

    /**
     * Alert ketika terjadi kesalahan
     */
    alertError(title, content, type:any = 'error') {
        let isi = '';
        if (Array.isArray(content) == true) {
            content.forEach(function(element) {
                isi = isi + element + ' <br>';
            });
        } else {
            if (typeof content === 'undefined') {
                isi = 'Terjadi kesalahan yang tidak terduga. Silakan coba lagi nanti.'
            } else {
                isi = String(content);
            }
        }
        return this.customAlert(
            'error',
            title,
            isi,
            false,
            false
        );
        // Swal.fire(title, isi, type);
    }
    alertWarning(title, content, type:any = 'warning') {
        let isi = '';
        if (Array.isArray(content) == true) {
            content.forEach(function(element) {
                isi = isi + element + ' <br>';
            });
        } else {
            isi = String(content);
        }
        Swal.fire(title, isi, type);
    }

    alertConfirm(title, text, confirmButtonText, cancelButtonText, type: any = 'warning'): any{
        return Swal.fire({
            title: this.translate.instant(title),
            text: this.translate.instant(text),
            icon: type,
            showCancelButton: true,
            confirmButtonColor: '#34c38f',
            cancelButtonColor: '#f46a6a',
            confirmButtonText: this.translate.instant(confirmButtonText),
            cancelButtonText: this.translate.instant(cancelButtonText)
        })
    }

    alertCustom(title, text, confirmButtonText, cancelButtonText, type: any = 'warning'): any{
        return Swal.fire({
            title: this.translate.instant(title),
            text: this.translate.instant(text),
            icon: type,
            showCancelButton: true,
            confirmButtonColor: '#55A89E',
            cancelButtonColor: '#50a5f1',
            confirmButtonText: this.translate.instant(confirmButtonText),
            cancelButtonText: this.translate.instant(cancelButtonText)
        })
    }

    customAlert(
        type,
        title,
        text,
        confirmButton: boolean = false,
        cancelButton: boolean = false,
        confirmText: any = 'Ya, Simpan!',
        cancelText: any = 'Batalkan',
        customHtml: any = null,
        timer: number = 2
    ): any {
        if (Array.isArray(text)) {
            text = text.join('<br>');
        }

        // Generate unique ID untuk lottie container agar tidak konflik
        const lottieId = `lottie-container-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        let lottieAnimation: any = null;

        const config: any = {
            title: '',
            html: `
                <div id="${lottieId}" class="swal2-custom-img" style="width:120px;height:120px;margin:0 auto;"></div>
                <h2 class="swal2-title">${this.translate.instant(title)}</h2>
                <div class="swal2-text">${this.translate.instant(text)}</div>
            `,
            showConfirmButton: confirmButton,
            showCancelButton: cancelButton,
            showCloseButton: true,
            confirmButtonText: this.translate.instant(confirmText),
            cancelButtonText: this.translate.instant(cancelText),
            customClass: {
                actions: 'swal2-vertical-buttons', // Kelas kustom untuk container tombol
                popup: 'swal2-custom-popup', // Kelas kustom untuk popup
                confirmButton: 'btn-primary swal2-custom-button', // Kelas untuk tombol konfirmasi
                cancelButton: 'btn btn-light swal2-custom-button-batalkan' // Kelas untuk tombol batal
            },
            buttonsStyling: false, // Tetap false agar customClass bekerja
            reverseButtons: false, // Atur ke false karena kita akan mengatur urutan dengan CSS/struktur
            allowOutsideClick: false,
            allowEscapeKey: false,
            onOpen: () => {
                const container = document.getElementById(lottieId);
                if (container) {
                    lottieAnimation = lottie.loadAnimation({
                        container: container,
                        renderer: 'svg',
                        loop: true,
                        autoplay: true,
                        path: `assets/images/alert/${type}.json`
                    });
                }
            },
            willClose: () => {
                // Destroy animasi lottie saat modal ditutup untuk mencegah memory leak
                if (lottieAnimation) {
                    lottieAnimation.destroy();
                    lottieAnimation = null;
                }
            }
        }

        if (confirmButton == false) {
            if (type == 'error') {
                config.timer = 3000;
            } else {
                config.timer = timer * 1000;
            }
        }

        if (customHtml) {
            config.html += customHtml;
        }

        return Swal.fire(config);
    }

    getDetailUser(){
        return this.userDetail;
    }

    validasiPassword(password){
        var hasNumber = /\d/;   
        var hasUpper = /[A-Z]/

        if((hasUpper.test(password)) && (hasNumber.test(password)) && password.length >= 6){
            return {
                status : true
            }
        }else{
            return {
                status : false,
                error : this.translate.instant('Gunakan minimal 6 karakter dengan campuran huruf kapital dan angka')
            };
        }
    }

    validasiEmail = (email) => {
        // Jika null format salah
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    };
    getDetailProject (){
        var data = {
            titleproject : '',
            slogan : '',
            no_wa : '',
            no_sales : '',
            folderimg : '',
            urlimg : ''
        }
        if (this.projectURL.includes('humanis')) {
            data.titleproject = "Humanis";
            data.slogan = "Lebih Praktis Pakai Humanis";
            data.no_wa =  "+628981000088";
            data.no_sales =  "+6285128043814";
            data.folderimg = "humanis/";
            data.urlimg = "assets/images/humanis/";
        } else if (this.projectURL.includes('salaree')) {
            data.titleproject = "Salaree";
            data.slogan = "Admin HR Mudah, Karyawan Happy";
            data.no_wa =  "+6285933100158";
            data.no_sales =  "+6285933100158";
            data.folderimg = "salaree/";
            data.urlimg = "assets/images/salaree/";
        } else {
            data.titleproject = "Humanis";
            data.slogan = "Lebih Praktis Pakai Humanis";
            data.no_wa =  "+628981000088";
            data.no_sales =  "+6285128043814";
            data.folderimg = "humanis/";
            data.urlimg = "assets/images/humanis/";
        }

        return data;
    }

    safeString(input: string): string {
        const key = 'encryptionhash';
        const iv = CryptoJS.SHA256('humanis2025*').toString(CryptoJS.enc.Hex).substr(0, 32); // ambil 32 char hex = 16 bytes

        const encrypted = CryptoJS.AES.encrypt(input, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Hex.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.toString();
    }

    unsafeString(encryptedText: string): string {
        const key = 'encryptionhash';
        const iv = CryptoJS.SHA256('humanis2025*').toString(CryptoJS.enc.Hex).substr(0, 32);

        const decrypted = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Hex.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    compareEncrypted(input: string, encrypted: string): boolean {
        const key = 'encryptionhash';
        const iv = CryptoJS.SHA256('humanis2025*').toString(CryptoJS.enc.Hex).substr(0, 32);

        const reEncrypted = CryptoJS.AES.encrypt(input, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Hex.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString();

        return reEncrypted === encrypted;
    }
}
